import { AvField, AvForm, AvInput } from "availity-reactstrap-validation";
import React, { Component } from "react";
//SweetAlert
import SweetAlert from "react-bootstrap-sweetalert";
//i18n
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Select from "react-select";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  FormGroup,
  Label,
} from "reactstrap";
//Import actions redux
import { getNullWsPositions, registerWorkstation } from "../../store/actions";

const types = [
  { name: "Esperar", value: "WAIT" },
  { name: "Liberar", value: "FREE" },
];

// const strictPriority = [
//   { name: "Si", value: 1},
//   { name: "No", value: 0}
// ];

class CreateWorkstationForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("authUser")),
      popup: false,
      pop_msg: null,
      pop_err: null,
      options: [
        { label: "Prova", value: "P" },
        { label: "Prova1", value: "P1" },
        { label: "Prova2", value: "P2" },
      ],
      selectedOptions: [],
    };
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.props.getNullWsPositions(this.state.user);
  }
  componentDidUpdate(prevProps) {
    if (
      this.props.loadingGetNullWsPositions === false &&
      prevProps.loadingGetNullWsPositions === true
    ) {
      let ws_positions = this.props.ws_positions;
      if (ws_positions) {
        this.prepareData(ws_positions);
      }
    }
    if (
      this.props.loadingCreateWS === false &&
      prevProps.loadingCreateWS === true
    ) {
      let msg = this.props.messageWS;
      let err = this.props.registrationWSError;
      console.log("msg: ", msg);
      console.log("err: ", err);
      if (msg) {
        this.setState({
          popup: true,
          pop_msg: "Estación de trabajo creada correctamente",
        });
      } /* if (err) */ else {
        this.setState({
          popup: true,
          pop_err: "No se ha podido crear la estación de trabajo",
        });
      }
    }
  } //Falta loader de carga mientras se genera el usuario
  prepareData(ws_positions) {
    let options = [];
    ws_positions.forEach((element) => {
      options.push({ label: element.ws_pos, value: element.ws_pos });
    });
    console.log(options);
    this.setState({ options: options, ws_positions: ws_positions });
  }
  // handleValidSubmit
  handleValidSubmit(event, values) {
    values["wspicking"] = parseInt(values["wspicking"]);
    values["wsmaxtasks"] = parseInt(values["wsmaxtasks"]);
    values["wsbuffer"] = parseInt(values["wsbuffer"]);
    let user = this.state.user;
    values["username"] = user.name;
    values["token"] = user.token;
    values["positions"] = [];

    this.state.selectedOptions.forEach((element) => {
      console.log(element);
      values["positions"].push(element.value);
    });

    console.log(values);

    this.props.registerWorkstation(values, this.props.history);
  }

  confirmPopup() {
    this.setState({ popup: false });
    this.props.history.push("/workstations");
  }

  handleChange(event) {
    console.log(event);
    this.setState({ selectedOptions: event });
  }
  render() {
    if (!this.state.ws_positions) {
      return <React.Fragment>Loading</React.Fragment>;
    }
    return (
      <React.Fragment>
        <Col lg="12">
          <Card>
            <CardBody>
              <CardTitle className="mb-4">
                {this.props.t("Crear nueva estación de trabajo")}
              </CardTitle>

              <AvForm
                className="needs-validation"
                onValidSubmit={this.handleValidSubmit}
              >
                <Col>
                  <FormGroup>
                    <Label htmlFor="validationCustom01">
                      Nombre de estación de trabajo
                    </Label>
                    <AvField
                      name="wsname"
                      placeholder="Nombre de estación de trabajo"
                      type="text"
                      errorMessage="Introduzca un nombre válido"
                      className="form-control"
                      validate={{ required: { value: true } }}
                      id="validationCustom01"
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label htmlFor="validationCustom05">Posiciones</Label>
                    <Select
                      id="select-multiple-new-workstations"
                      defaultValue={this.state.selectedOptions}
                      isMulti
                      placeholder={this.props.t("Seleccionar posiciones")}
                      onChange={this.handleChange}
                      options={this.state.options}
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup
                    errorMessage={this.props.t(
                      "Introduzca valor de picking válido"
                    )}
                  >
                    <Label htmlFor="validationCustom02">
                      {this.props.t("Tiempo de picking")}
                    </Label>
                    <AvField
                      name="wspicking"
                      placeholder={this.props.t(
                        "Introduzca el tiempo de picking"
                      )}
                      type="text"
                      className="form-control"
                      validate={{
                        required: { value: true },
                        min: { value: -1 },
                      }}
                      errorMessage={this.props.t(
                        "Introduzca valor de picking válido"
                      )}
                      id="validationCustom02"
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup
                    errorMessage={this.props.t(
                      "Introduzca valor de tareas válido"
                    )}
                  >
                    <Label htmlFor="validationCustom02">
                      {this.props.t("Tareas Máximas")}
                    </Label>
                    <AvField
                      name="wsmaxtasks"
                      placeholder={this.props.t(
                        "Introduzca el máximo de tareas a procesar"
                      )}
                      type="text"
                      className="form-control"
                      validate={{
                        required: { value: true },
                        min: { value: 0 },
                      }}
                      errorMessage={this.props.t(
                        "Introduzca valor de tareas válido"
                      )}
                      id="validationCustom02"
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup
                    errorMessage={this.props.t(
                      "Introduzca tamaño de buffer válido"
                    )}
                  >
                    <Label htmlFor="validationCustom02">
                      {this.props.t("Buffer físico")}
                    </Label>
                    <AvField
                      name="wsbuffer"
                      placeholder={this.props.t(
                        "Introduzca el tamaño del buffer físico"
                      )}
                      type="text"
                      className="form-control"
                      validate={{
                        required: { value: true },
                        min: { value: 0 },
                      }}
                      errorMessage={this.props.t(
                        "Introduzca tamaño de buffer válido"
                      )}
                      id="validationCustom02"
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup
                    errorMessage={this.props.t(
                      "Introduzca tamaño de buffer válido"
                    )}
                  >
                    <Label htmlFor="validationCustom02">
                      {this.props.t("Area rebotes")}
                    </Label>
                    <AvField
                      name="inboundArea"
                      placeholder={this.props.t("Introduzca área de rebotes")}
                      type="text"
                      className="form-control"
                      validate={{
                        required: { value: false },
                        min: { value: 0 },
                      }}
                      errorMessage={this.props.t(
                        "Introduzca valor de area válido"
                      )}
                      id="validationCustom02"
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup
                    errorMessage={this.props.t("Introduzca valor válido")}
                  >
                    <Label htmlFor="validationCustom02">
                      {this.props.t("Estrategia rebotes")}
                    </Label>
                    <AvField
                      name="strategyInbound"
                      placeholder={this.props.t(
                        "Introduzca la estrategia de rebotes"
                      )}
                      type="text"
                      className="form-control"
                      validate={{
                        required: { value: false },
                        min: { value: 0 },
                      }}
                      errorMessage={this.props.t(
                        "Introduzca tamaño de buffer válido"
                      )}
                      id="validationCustom02"
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label htmlFor="validationCustom05">
                      Actuación por defecto
                    </Label>
                    <AvInput
                      value={types[0].value}
                      name="wstype"
                      placeholder="Actuación por defecto"
                      type="select"
                      errorMessage="Introduzca una actuación válida"
                      className="form-control"
                      validate={{ required: { value: true } }}
                      id="validationCustom09"
                    >
                      {types.map((type, key) => (
                        <option key={key} value={type.value}>
                          {type.name}
                        </option>
                      ))}
                    </AvInput>
                  </FormGroup>
                </Col>

                <Button color="primary" type="submit">
                  Crear estación de trabajo
                </Button>
              </AvForm>

              {this.state.popup ? (
                <SweetAlert
                  type={this.state.pop_msg ? "success" : "error"}
                  title={
                    this.state.pop_msg ? this.state.pop_msg : this.state.pop_err
                  }
                  confirmBtnText={this.props.t("ok")}
                  onConfirm={() => this.confirmPopup()}
                ></SweetAlert>
              ) : null}
            </CardBody>
          </Card>
        </Col>
      </React.Fragment>
    );
  }
}

const mapStateprops = (state) => {
  const { registrationWSError, messageWS, loadingCreateWS } = state.CreateWS;
  const { ws_positions, loadingGetNullWsPositions } = state.GetNullWSPositions;
  return {
    registrationWSError,
    messageWS,
    loadingCreateWS,
    ws_positions,
    loadingGetNullWsPositions,
  };
};
export default withRouter(
  connect(mapStateprops, { registerWorkstation, getNullWsPositions })(
    withNamespaces()(CreateWorkstationForm)
  )
);
